import request from 'superagent'

import endpoints from '../config/endpoints'

export default () =>
  new Promise((resolve, reject) =>
    request
      .get(endpoints.user)
      .then((result) => {
        if (!result.body) return console.error('Invalid response: ', result)
        return resolve(result.body)
      })
      .catch((error) => reject(new Error(error))),
  )

export const getTrolleyCount = () =>
  new Promise((resolve, reject) =>
    request
      .get(endpoints.trolleyCount)
      .ok((res) => res.status < 500)
      .then((result) => {
        if (!result.body && result.body !== 0) {
          return reject(new Error(`Invalid response: ${result.body}`))
        }
        // return resolve(1) // testing
        return resolve(result.body)
      })
      .catch((error) => {
        return reject(new Error(error))
      }),
  )

export const signOut = ({ storeId, langId, catalogId }) =>
  new Promise((resolve, reject) =>
    request
      .get(`${endpoints.signOut}?storeId=${storeId}&langId=${langId}&catalogId=${catalogId}`)
      .then((result) => {
        if (result.statusCode !== 200) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject({ signedOut: false })
        }

        return resolve({ signedOut: true })
      })
      // eslint-disable-next-line prefer-promise-reject-errors
      .catch((error) => reject({ signedOut: false, error })),
  )
